module.exports = __webpack_public_path__ + "img/d6506.27aff865.png";